<template>
  <div v-if="isdisplay" class="pmod-overlay" @click.self="close">
    <div class="pmod-dialog">

      <!-- Header -->
      <div class="pmod-head">
        <div class="pmod-head-left">
          <div class="pmod-head-icon"><i class="ri-pencil-line"></i></div>
          <span>Modifier la quantité</span>
        </div>
        <button class="pmod-close" @click="close" aria-label="Fermer">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="pmod-body">
        <div class="pmod-article-label">
          <template v-if="Items.autredesignation === ''">
            {{ Items.article.libelle }}
          </template>
          <template v-else>
            {{ Items.article.libelle + ' (' + Items.autredesignation + ')' }}
          </template>
        </div>

        <input
          type="number"
          v-model="newqte"
          class="pmod-input"
          min="0"
          step="1"
          autofocus
        />
      </div>

      <!-- Footer -->
      <div class="pmod-foot">
        <button class="pmod-btn-sec" @click="close">Annuler</button>
        <button class="pmod-btn-pri" @click="selected">
          <i class="ri-check-line"></i> Valider
        </button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  name: "formsupp",

  data() {
    return {
      isdisplay: false,
      datavalue: "",
      titlemodal: "",
      Items: {},
      accompagnement: {},
      typedoc: "",
      messageerror: "",
      messagesucces: "",
      newqte: 0,
      oldqte: 0,
    };
  },

  methods: {
    selected() {
      const elementSelectionne = { item: this.Items, newqte: this.newqte, oldqte: this.oldqte };
      this.$emit('updateqteitem', elementSelectionne);
      this.isdisplay = false;
    },

    close() {
      this.isdisplay = false;
    },

    show(Items) {
      this.Items = Items;
      this.newqte = this.Items.qtite;
      this.oldqte = this.Items.qtite;
      this.isdisplay = true;
    },
  },

  mounted() {
    // this.loaddata();
  },
};
</script>

<style scoped>
/* ── Overlay ── */
.pmod-overlay {
  position: fixed; inset: 0; z-index: 10030;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: 'Segoe UI', system-ui, sans-serif;
}

/* ── Dialog ── */
.pmod-dialog {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 14px; width: min(360px, 100%);
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
  animation: pmod-in .2s cubic-bezier(.4, 0, .2, 1);
}
@keyframes pmod-in {
  from { opacity: 0; transform: scale(.93) translateY(10px); }
  to   { opacity: 1; transform: none; }
}

/* ── Header ── */
.pmod-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
}
.pmod-head-left {
  display: flex; align-items: center; gap: 10px;
  font-size: 14px; font-weight: 800; color: var(--text);
}
.pmod-head-icon {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 17px;
  display: flex; align-items: center; justify-content: center;
}
.pmod-close {
  background: none; border: none; color: var(--text2); font-size: 20px;
  cursor: pointer; line-height: 1; padding: 4px; border-radius: 6px;
  transition: color .12s;
}
.pmod-close:hover { color: var(--red); }

/* ── Body ── */
.pmod-body {
  padding: 20px 18px; display: flex; flex-direction: column; gap: 16px;
  overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.pmod-article-label {
  display: block; text-align: center;
  font-size: 15px; font-weight: 700; color: var(--text);
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 10px; padding: 12px 14px; line-height: 1.4;
}
.pmod-input {
  width: 100%; padding: 14px 12px; border-radius: 10px;
  background: var(--surface2); border: 2px solid var(--border);
  color: var(--text); font-size: 26px; font-weight: 800;
  text-align: center; outline: none; font-family: inherit;
  transition: border-color .15s;
  -moz-appearance: textfield;
}
.pmod-input::-webkit-outer-spin-button,
.pmod-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.pmod-input:focus { border-color: var(--accent); }

/* ── Footer ── */
.pmod-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 14px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}
.pmod-btn-sec {
  padding: 9px 16px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.pmod-btn-sec:hover { border-color: var(--red); color: var(--red); }
.pmod-btn-pri {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 20px; border-radius: 8px; border: none;
  background: var(--accent); color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: opacity .12s;
}
.pmod-btn-pri:hover { opacity: .88; }

/* ── Mobile bottom-sheet ── */
@media (max-width: 640px) {
  .pmod-overlay { align-items: flex-end; padding: 0; }
  .pmod-dialog {
    width: 100%; border-radius: 16px 16px 0 0;
    animation: pmod-slide-up .25s cubic-bezier(.4, 0, .2, 1);
  }
}
@keyframes pmod-slide-up {
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
</style>
